module.exports = __webpack_public_path__ + "static/media/card-external-site.7a04021b.png";